import styled from 'styled-components';
import Ico20 from 'dc/Ico20';

export const Button = styled.button`
  width: 48px;
  height: 48px;
  background: transparent;
  border: none;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  &:disabled div {
    background-color: ${props => (props.checked ? '#eceff1' : 'transparent')};
    border-color: ${props => (props.checked ? '#eceff1' : '#eceff1')};
  }
  &:disabled i {
    color: ${props => (props.checked ? '#fff' : '#eceff1')};
  }
`;

export const Circle = styled.div`
  border: 2px solid #cfd8dc;
  border-radius: 100%;
  padding: 0;
  height: 36px;
  width: 36px;
  display: inline-block;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  background-color: ${props => (props.checked ? '#00AB97' : 'transparent')};
  border-color: ${props => (props.checked ? '#00AB97' : '#CFD8DC')};
  &:hover {
    border: 2px solid #00ab97;
    border-color: ${props => (props.checked ? '#009483' : '#00AB97')};
    background-color: ${props => (props.checked ? '#009483' : '#fff')};
  }
  &:hover i {
    color: ${props => {
      const checkedDependantColor = props.checked ? '#fff' : '#00AB97';

      return props.disabled ? '#eceff1' : checkedDependantColor;
    }};
  }
`;

export const Icon = styled(Ico20)`
  color: ${props => (props.checked ? '#fff' : '#607D8B')};
  text-align: center;
  display: inline-block;
  margin: 5px 6px 6px 6px;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
`;
